'use es6';

import I18n from 'I18n';
import { PropertyObjectTypes, PropertyObjectTypesIds } from 'FormsCommonComponents/js/constants/PropertyObjectTypes';
export const handleRequiredProperties = (properties = [], objectTypes) => {
  const getObjectTypeLabel = objectTypeId => objectTypes.find(objType => objType.objectTypeId === objectTypeId).objectTypeLabel;
  return properties.reduce((acc, property) => Object.assign({}, acc, {
    [property.objectTypeId]: Object.assign({
      objectTypeLabel: getObjectTypeLabel(property.objectTypeId)
    }, acc[property.objectTypeId], {
      [property.name]: property
    })
  }), {});
};
export const handleObjectTypesMerge = ({
  id,
  data
}, state) => state.objectTypes.map(objectType => objectType.objectTypeId === id ? data : objectType);
export const flattenObjects = ({
  data
}, state) => Object.assign({}, state.flattenedObjects, {
  [data.objectTypeId]: data.propertyGroups.reduce((acc, group) => {
    if (group && group.properties && Array.isArray(group.properties)) {
      group.properties.forEach(property => {
        acc = Object.assign({}, acc, {
          [property.name]: Object.assign({}, property, {
            originalLabel: property.label,
            id: `${property.objectTypeId}/${property.name}`
          })
        });
      });
    }
    return acc;
  }, {})
});
export const handleAddingPropertiesToEditorViaWarnings = ({
  properties = [],
  formFieldGroups = [],
  addFormFieldGroup = () => {}
}) => {
  properties.forEach((property, idx) => {
    addFormFieldGroup(`${property.objectTypeId}/${property.name}`, formFieldGroups.length + idx);
  });
};
const objectIsNotDealType = objectType => objectType.objectTypeId !== PropertyObjectTypesIds[PropertyObjectTypes.DEAL];
export const handleObjectTypeIdsToNameMap = ({
  objectTypes = []
}) => objectTypes.filter(objectIsNotDealType).reduce((acc, {
  objectTypeId,
  objectTypeLabel
}) => Object.assign({}, acc, {
  [objectTypeId]: objectTypeLabel
}), {});
export const getPropertyByObjectTypeIdMap = ({
  flattenedObjects
}) => Object.keys(flattenedObjects).reduce((acc, key) => {
  Object.values(flattenedObjects[key]).forEach(property => {
    acc = Object.assign({}, acc, {
      [property.id]: property
    });
  });
  return acc;
}, {});
export const getLabelForObject = (objectTypeId, objectTypeLabels) => objectTypeLabels[objectTypeId] || I18n.text('unknown');